import React, { useEffect } from "react";
import { SectionHeader, SectionInfo } from ".";
import { RadioGroup, FormControlLabel, Radio, makeStyles, FormHelperText } from "@material-ui/core";
var useStyles = makeStyles({
  descriptionInfoSection: {
    marginBottom: "0.5em"
  },
  formControl: {
    alignItems: "flex-start"
  },
  option: {
    margin: "0 9px 9px 9px",
    padding: 0
  },
  optionLabel: {
    display: "flex"
  },
  error: {
    color: "red"
  }
});
var ConsentOption = function ConsentOption(_ref) {
  var title = _ref.title,
    description = _ref.description,
    yesText = _ref.yesText,
    noText = _ref.noText,
    value = _ref.value,
    onChange = _ref.onChange,
    readonly = _ref.readonly,
    errorText = _ref.errorText;
  var classes = useStyles();
  var radioValue = value === true ? "yes" : value === false ? "no" : "";
  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event.target.value === "yes");
    }
  };
  var handleRadioClick = function handleRadioClick(event) {
    var selected = event.target.value;
    if (onChange) {
      if (radioValue === selected) {
        onChange(false); // deselect
      } else {
        onChange(selected === "yes");
      }
    }
  };
  // to default to "No" and call the onChange so it saves in the order
  useEffect(function () {
    if (radioValue === undefined && !readonly && onChange) {
      if (title === "Consent for Testing") {
        onChange(false); // set default to "No" for "Consent for Testing"
      } else {
        onChange(title === "Consent for Testing");
      }
    }
  }, [radioValue, readonly, onChange, title]);
  var ReadOnly = function ReadOnly() {
    return React.createElement(React.Fragment, null, value && React.createElement(SectionInfo, {
      style: {
        display: "flex"
      }
    }, React.createElement("span", {
      style: {
        display: "inline-block",
        textAlign: "left",
        width: "2.25em",
        marginRight: "0.25em",
        flex: "0 0 auto"
      }
    }, React.createElement("b", null, "YES")), " ", yesText), !value && React.createElement(SectionInfo, {
      style: {
        display: "flex"
      }
    }, React.createElement("span", {
      style: {
        display: "inline-block",
        textAlign: "left",
        width: "2.25em",
        marginRight: "0.25em",
        flex: "0 0 auto"
      }
    }, React.createElement("b", null, "NO")), " ", noText && React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: String(noText)
      }
    })));
  };
  var Editable = function Editable() {
    return React.createElement(RadioGroup, {
      value: radioValue,
      onChange: handleChange
    }, React.createElement(FormControlLabel, {
      control: React.createElement(Radio, {
        className: classes.option
      }),
      classes: {
        root: classes.formControl
      },
      label: React.createElement(SectionInfo, {
        className: classes.optionLabel
      }, React.createElement("span", {
        style: {
          display: "inline-block",
          textAlign: "left",
          width: "2.25em",
          marginRight: "0.25em",
          flex: "0 0 auto"
        }
      }, React.createElement("b", null, "YES")), " ", yesText),
      value: "yes"
    }), React.createElement(FormControlLabel, {
      control: React.createElement(Radio, {
        className: classes.option
      }),
      classes: {
        root: classes.formControl
      },
      label: React.createElement(SectionInfo, {
        className: classes.optionLabel
      }, React.createElement("span", {
        style: {
          display: "inline-block",
          textAlign: "left",
          width: "2.25em",
          marginRight: "0.25em",
          flex: "0 0 auto"
        }
      }, React.createElement("b", null, "NO")), " ", noText),
      value: "no",
      style: {
        marginTop: "0.5em"
      }
    }));
  };
  // Titles for which a single checkbox toggle should be shown when only yesText exists
  var singleToggleTitles = ["Option for Reporting of Incidental Findings", "Option for Reporting Findings in Genes with No Known Disease Association", "For Samples Submitted from New York State"];
  // Render a single Radio that can be toggled on (checked) and off (unchecked) by clicking again
  var EditableSingleRadioToggle = function EditableSingleRadioToggle() {
    var isChecked = value === true;
    var handleRadioChange = function handleRadioChange(event) {
      if (onChange) {
        onChange(true);
      }
    };
    var handleRadioClick = function handleRadioClick() {
      if (onChange && isChecked) {
        onChange(false);
      }
    };
    return !readonly ? React.createElement(FormControlLabel, {
      control: React.createElement(Radio, {
        className: classes.option,
        checked: isChecked,
        onChange: handleRadioChange,
        onClick: handleRadioClick
      }),
      classes: {
        root: classes.formControl
      },
      label: React.createElement(SectionInfo, {
        className: classes.optionLabel
      }, yesText)
    }) : null;
  };
  //Component to show only available radio option on the basis of text.
  var EditableSingle = function EditableSingle() {
    return !readonly ? React.createElement(RadioGroup, {
      value: radioValue,
      onChange: handleChange
    }, yesText && React.createElement(FormControlLabel, {
      control: React.createElement(Radio, {
        className: classes.option
      }),
      classes: {
        root: classes.formControl
      },
      label: React.createElement(SectionInfo, {
        className: classes.optionLabel
      }, yesText),
      onClick: handleRadioClick,
      value: "yes"
    }), noText && React.createElement(FormControlLabel, {
      control: React.createElement(Radio, {
        className: classes.option
      }),
      classes: {
        root: classes.formControl
      },
      label: React.createElement(SectionInfo, {
        className: classes.optionLabel
      }, noText),
      onClick: handleRadioClick,
      value: "no",
      style: {
        marginTop: "0.5em"
      }
    })) : null;
  };
  // Show both options if both texts are provided or neither is provided
  var shouldShowEditable = !!yesText && !!noText || !yesText && !noText;
  // Determine if we should render a single checkbox toggle for specific titles
  var shouldUseSingleToggle = !readonly && !!yesText && !noText && typeof title === "string" && singleToggleTitles.includes(title);
  return React.createElement("div", {
    style: {
      breakInside: "avoid"
    }
  }, title && React.createElement(SectionHeader, {
    style: {
      marginTop: "1.5em"
    }
  }, title), description && React.createElement("div", {
    style: {
      marginBottom: "0.5em"
    }
  }, React.createElement(SectionInfo, null, description)), readonly && React.createElement(ReadOnly, null), !readonly && (shouldUseSingleToggle ? React.createElement(EditableSingleRadioToggle, null) : shouldShowEditable ? React.createElement(Editable, null) : React.createElement(EditableSingle, null)), errorText && React.createElement(FormHelperText, {
    className: classes.error
  }, errorText), React.createElement("br", null));
};
export default ConsentOption;